import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setUser, logOut } from '../store/slices/authSlice';
import { authApi } from '../services/api';
import { useNavigate } from 'react-router-dom';

export const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const verifySession = async () => {
      try {
        const response = await authApi.verifyAccess();
        
        if (response.message === 'Valid Session' && response.data) {
          // Map roles to the expected format
          const roles = response.data.roles?.includes('admin') ? '1' : '2';
          
          dispatch(setUser({
            companyID: response.data.companyID,
            companyName: response.data.companyName,
            username: response.data.username,
            email: response.data.email,
            roles
          }));
        } else {
          console.error('Invalid session response:', response);
          dispatch(logOut());
          navigate('/login', { replace: true });
        }
      } catch (error: any) {
        console.error('Session verification failed:', error);
        dispatch(logOut());
        // If error is 401 or network, redirect to login
        navigate('/login', { replace: true });
      }
    };

    // Verify session immediately on mount
    verifySession();
    
    // Then set up interval for periodic checks
    const interval = setInterval(verifySession, 5 * 60 * 1000);
    
    return () => clearInterval(interval);
  }, [dispatch, navigate]);
};